import { render, staticRenderFns } from "./FolderContent.vue?vue&type=template&id=79d36a20&scoped=true&"
import script from "./FolderContent.vue?vue&type=script&lang=js&"
export * from "./FolderContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d36a20",
  null
  
)

export default component.exports